import { render } from "./CommonUpload.vue?vue&type=template&id=2890d9e7&scoped=true"
import script from "./CommonUpload.vue?vue&type=script&lang=js"
export * from "./CommonUpload.vue?vue&type=script&lang=js"

import "./CommonUpload.vue?vue&type=style&index=0&id=2890d9e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2890d9e7"]])

export default __exports__